// 将作者分组
import { getUserLocalInfo } from "Methods/user"
import { Author, GroupAuthor } from "Types/author"

export function groupAuthor(authors?: Author[]) {
    const { uid: currentUserUid } = getUserLocalInfo()
    // 关联当前用户的作者
    const relatedAuthor: Author[] = []
    // 已关联用户的作者
    const associateAuthor: { [key: string]: Author[] } = {}
    // 用户分组数
    const authorList: GroupAuthor[] = []
    if (authors) {
        authors.forEach((author: Author) => {
            const { user_public, uid } = author
            if (currentUserUid === uid) {
                relatedAuthor.push(author)
            } else if (uid && user_public) {
                const { department: { name }} = user_public
                if (!associateAuthor[name]) {
                    associateAuthor[name] = []
                }
                associateAuthor[name].push(author)
            }
        })
    }
    authorList.push({ name: "已关联作者", authors: relatedAuthor })
    Object.keys(associateAuthor).forEach((key: string) => {
        authorList.push({ name: key, authors: associateAuthor[key] })
    })
    return { relatedAuthor, associateAuthor, authorList }
}
